import { Calendar, Clock } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { memo } from 'react'

interface DateDisplayProps {
  createdAt: string
  updatedAt: string
}

// Cache for DateTimeFormat instances per language
const formatters = new Map<string, Intl.DateTimeFormat>()

function getFormatter(language: string): Intl.DateTimeFormat {
  if (!formatters.has(language)) {
    formatters.set(language, new Intl.DateTimeFormat(language, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }))
  }
  return formatters.get(language)!
}

function DateDisplay({ createdAt, updatedAt }: DateDisplayProps) {
  const { i18n } = useTranslation()
  const formatter = getFormatter(i18n.language)

  return (
    <div className="flex flex-col gap-1 text-xs">
      <div className="flex items-center gap-1.5 text-base-content/70">
        <Calendar className="w-3 h-3" />
        <span>{formatter.format(new Date(createdAt))}</span>
      </div>
      <div className="flex items-center gap-1.5 text-base-content/70">
        <Clock className="w-3 h-3" />
        <span>{formatter.format(new Date(updatedAt))}</span>
      </div>
    </div>
  )
}

// Memo prevents re-rendering icons when dates haven't changed
export default memo(DateDisplay)
